export default __webpack_public_path__ + "static/media/image.2c37d663.jpg";